import React from 'react';
import { SwiperSlide } from 'swiper/react';
import { Carousel, CarouselWrapper } from '$partials/base/carousel';
import PropertyListingItem from '$partials/items/property-listing-item';
import { Button } from '$partials/ui';
import IconChevron from '$partials/icons/icon-chevron';
import { useOffice } from '$contexts/office';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').OfficeSalePropertiesBlock}
 */

const OfficeSalePropertiesBlock = ({
    heading,
}) => {

    const { saleProperties, externalId } = useOffice();
    const items = saleProperties?.edges?.map?.(edge => edge?.node)?.filter?.(Boolean);

    const swiperConfig = {
        slidesPerView: 'auto',
        width: 'auto',
        spaceBetween: 0
    };

    if (!items?.length) {
        return null;
    }

    const listingPageUrl = items[0]?.url?.split('/')?.filter((_, i, { length }) => i < length - 1).join('/');

    return (
        <div className='module-property-card-carousel theme-light bg-main-background'>
            <div className='py-16 sm:py-40 md:py-48'>
                <Carousel swiperConfig={swiperConfig}>
                    <div className='flex flex-col gap-16 sm:gap-24 w-full mx-auto'>
                        {/* Header with title and controls */}
                        <div className='layout-container layout-site-outer-padding flex flex-col sm:flex-row gap-24 sm:gap-8 items-start sm:items-baseline w-full'>
                            {/* Title */}
                            <div className='flex-1 flex flex-col gap-24 items-start'>
                                {heading && (
                                    <h2 className='type-style-2 text-main-text-primary w-full'>
                                        {heading}
                                    </h2>
                                )}
                            </div>

                            {/* Controls */}
                            <div className='hidden sm:flex items-center justify-end gap-16'>
                                <Button
                                    as='a'
                                    className='button-primary-transparent button-primary-transparent--small px-12 py-7 rounded flex gap-2 items-center justify-center type-style-eyebrow'
                                    href={`${listingPageUrl}?officeId=${encodeURIComponent(externalId)}`}>
                                    view all
                                    <IconChevron className='ml-10 -rotate-90' />
                                </Button>
                            </div>
                        </div>

                        {/* Carousel */}
                        <div className='overflow-hidden w-full max-w-screen left-1/2 relative -translate-x-1/2'>
                            <div className='layout-container layout-site-outer-padding overflow-visible'>
                                <div className='col-wrapper'>
                                    <CarouselWrapper>
                                        {items?.map((property, index) => (
                                            <SwiperSlide
                                                className='w-10/12 sm:w-5/12 md:w-4/12 flex'
                                                key={property?.id || index}>
                                                <PropertyListingItem
                                                    className='col-padding'
                                                    {...property} />
                                                {index < items.length - 1 && (
                                                    <div className='shrink-0 w-[1px] h-full bg-main-border'></div>
                                                )}
                                            </SwiperSlide>
                                        ))}
                                    </CarouselWrapper>
                                </div>
                            </div>
                        </div>
                    </div>

                </Carousel>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default OfficeSalePropertiesBlock;
